import React from 'react';
import { HomeAssignmentBoard } from './HomeAssignmentBoard';

export { HomeAssignmentPage };

function HomeAssignmentPage() {
    return (
        <div className="p-4">
            <HomeAssignmentBoard />
        </div>
    );
}
